var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconsBlackColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6506_111220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5,
    height: 34.5,
    transform: "translate(0.5 0.75)",
    fill: "#C8D2F8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6506_111220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.96776C23.2317 10.7041 24.25 12.2331 24.25 14C24.25 15.7669 23.2317 17.2959 21.75 18.0322M23.75 23.2664C25.2615 23.9503 26.6225 25.065 27.75 26.5M7.75 26.5C9.69649 24.0226 12.3392 22.5 15.25 22.5C18.1608 22.5 20.8035 24.0226 22.75 26.5M19.75 14C19.75 16.4853 17.7353 18.5 15.25 18.5C12.7647 18.5 10.75 16.4853 10.75 14C10.75 11.5147 12.7647 9.5 15.25 9.5C17.7353 9.5 19.75 11.5147 19.75 14Z",
    stroke: "#071135",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6506_111220"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6506_111220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(6.25 6.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconsBlackColor);
export default __webpack_public_path__ + "static/media/user-icons-black-color.c89738231e736cdc62d8ce062420454e.svg";
export { ForwardRef as ReactComponent };